import React from 'react';
import { BooleanBubbleStyled } from './styles';

const BooleanBubble = ({ value }) => {
  if (value === undefined || value === null || value === '') return null;
  const isTrue = value === true || value === 'true' || value === 'True';
  return <BooleanBubbleStyled $isTrue={isTrue}>{isTrue ? 'True' : 'False'}</BooleanBubbleStyled>;
};

export default BooleanBubble;
